import React from "react";
import { createUseStyles } from "react-jss";
var useStyles = createUseStyles({
    svg: {
        fill: function (props) { return props.color; },
        width: 26,
        height: 26,
        userSelect: "none",
    }
});
export default function AddTeamIcon(_a) {
    var color = _a.color;
    var classes = useStyles({ color: color });
    return (React.createElement("svg", { viewBox: "0 0 65 66", className: classes.svg },
        React.createElement("path", { d: "M32.4,63.1c-16.4,0-29.8-13.4-29.8-29.8S15.9,3.6,32.4,3.6S62.1,17,62.1,33.4S48.8,63.1,32.4,63.1z M32.4,9.4\n\t\t\t\t\tc-13.2,0-24,10.8-24,24s10.8,24,24,24s24-10.8,24-24S45.6,9.4,32.4,9.4z" }),
        React.createElement("path", { d: "M21.2,30.4H30v-8.8h6v8.8h8.8v6h-8.8v8.7h-6v-8.7h-8.8V30.4z" })));
}
//# sourceMappingURL=AddTeamIcon.js.map